import React from 'react'
import Navbar from './Navbar'
import Footer from './Footer'
import Whatsapp from './Whatsapp'
import { ZoomableImage } from './ImageLightbox'

const RSVP_URL = 'https://forms.gle/HjnbriGPaYMerXq96'

const VENUE_ADDRESS = '16260 Kensington Dr Suite B, Sugar Land, TX 77478'

function RegisterButton({ children, className = 'bnt bnt-theme event-register-btn' }) {
  return (
    <a
      href={RSVP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      {children}
    </a>
  )
}

export default function Events() {
  return (
    <>
      <div className="main-wrapper page page-events">
        <Navbar />
        <div className="content-wrapper">
          {/* Hero */}
          <div className="program-upcoming-event">
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-sm-12 col-xs-12">
                  <div className="area-img">
                    <img
                      className="img-responsive animate zoomIn"
                      src="/images/events/retreat-save-the-date-2026.png"
                      alt="LIT Alumni Association North America Chapter Alumni Retreat 2026"
                    />
                  </div>
                </div>
                <div className="col-md-6 col-sm-12 col-xs-12">
                  <div className="area-content">
                    <div className="area-top">
                      <div className="top-section animated lightSpeedIn">
                        <span className="event-badge">INAUGURAL EVENT</span>
                        <span className="event-draft-badge">DRAFT PROGRAMME</span>
                        <h5 className="heading-light">FEATURED EVENT</h5>
                        <span className="dates text-uppercase">
                          September 11–13, 2026
                        </span>
                      </div>
                      <h2 className="heading-bold animated rollIn">
                        LITAA North America Chapter — Inaugural Alumni Weekend Retreat
                      </h2>
                      <span className="event-hero-location animated fadeIn">
                        <i className="fa fa-map-marker" aria-hidden="true" />
                        <span className="text-place">
                          Sugar Land, Texas
                        </span>
                      </span>
                      {/* Old: Houston, Texas — venue TBD · Capacity: ~25 alumni
                      <p className="text-light">Weekend retreat — core programming Saturday...</p>
                      */}
                      <p className="event-hero-detail">
                        Weekend retreat — core programming Saturday, optional events Friday &amp; Sunday.
                        <br />
                        <strong>Venue:</strong> {VENUE_ADDRESS}
                        <br />
                        <strong>Capacity:</strong> 20–25 alumni
                      </p>
                    </div>
                    <div className="area-bottom animated zoomInLeft">
                      {/* Old: Link to="/contactus" Register Your Interest */}
                      <RegisterButton>Register Now</RegisterButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Dear Fellow LITians callout */}
          <section className="event-callout" data-aos="fade-up">
            <div className="container">
              <div className="event-callout__inner">
                <h2>Dear Fellow LITians 🌟</h2>
                <p>Something historic is happening this September — and it only happens once.</p>
                <p>
                  For the first time ever, the LIT Alumni Association North America Chapter is coming together in person. In Houston. On September 11–13 with full day program on Saturday, the 12th. Our very first retreat.
                </p>
                <p>
                  Nearly ~150 LITians call North America home. Yet only about 25–30 have said yes.
                </p>
                <p>Think about that for a moment.</p>
                <p>
                  We carry the same alma mater, the same memories, the same pride in where we came from. This retreat is our chance to honor that — together, in person — and to launch something that will grow for generations of LITians to come.
                </p>
                <p><strong>There will never be another first retreat. This is it.</strong></p>
                <p><strong>If not now, when? If not you, who?</strong></p>
                <p>Register today. Let&apos;s make history together. 🔥</p>
                <p className="event-callout__signoff">— LITAANA Organizing Committee</p>
                <RegisterButton className="bnt bnt-theme event-register-btn event-register-btn--large">
                  Register Today
                </RegisterButton>
              </div>
            </div>
          </section>

          {/* Zoomable flyers */}
          <section className="event-flyer-gallery" data-aos="fade-up">
            <div className="container">
              <h2>Event Flyers</h2>
              <p className="event-section-intro">Tap or click any flyer to view full size.</p>
              <div className="event-flyer-gallery__grid">
                <ZoomableImage
                  src="/images/events/retreat-save-the-date-2026.png"
                  alt="Save the Date — North America Chapter Alumni Retreat 2026"
                  caption="Save the Date — Alumni Retreat 2026"
                />
                <ZoomableImage
                  src="/images/events/lit-north-star-award-2026.png"
                  alt="LIT North Star Award — Inaugural presentation at the Houston retreat"
                  caption="LIT North Star Award 2026"
                />
              </div>
            </div>
          </section>

          {/* Overview + programme */}
          <section className="event-programme" data-aos="fade-up">
            <div className="container">
              <h2>Overview</h2>
              <div className="event-overview-grid">
                <div className="event-overview-grid__item">
                  <strong>Dates</strong>
                  <span>Friday, September 11 – Sunday, September 13, 2026</span>
                </div>
                <div className="event-overview-grid__item">
                  <strong>Location</strong>
                  <span>{VENUE_ADDRESS}</span>
                </div>
                <div className="event-overview-grid__item">
                  <strong>Attendees</strong>
                  <span>20–25 alumni — LIT North America Chapter</span>
                </div>
                <div className="event-overview-grid__item">
                  <strong>Format</strong>
                  <span>Weekend retreat — core programming Saturday, optional events Fri &amp; Sun</span>
                </div>
              </div>

              {/* Old About This Retreat — commented per content update
              <h3>About This Retreat</h3>
              <p>This is our first-ever gathering...</p>
              */}

              <h3>Weekend Agenda</h3>

              <h4>Friday, September 11 — Arrival Day</h4>
              <ul>
                <li><strong>7:00 PM — Meet &amp; Greet Dinner [OPTIONAL]</strong> — Casual welcome dinner at a Houston restaurant — first chance to reconnect. No formal agenda.</li>
              </ul>

              <h4>Saturday, September 12 — Main Event</h4>
              <ul>
                <li><strong>9:00 AM — Welcome &amp; Registration</strong> — Full breakfast, name tags, and intro remarks from chapter leadership.</li>
                <li><strong>10:00 AM — Alumni Spotlight Talks</strong> — 3–4 short talks (10 min each) from alumni on career journeys, research, or industry insights.</li>
                <li><strong>11:30 AM — Panel Discussion</strong> — Moderated panel of 3–4 alumni — &quot;Chemical Engineering careers across industries&quot; — with open Q&amp;A.</li>
                <li><strong>12:30 PM — Lunch &amp; Networking</strong> — Catered lunch with a structured mix-and-mingle activity.</li>
                <li><strong>2:00 PM — Roundtable Discussions</strong> — Small groups by industry or interest (tech, energy, consulting, etc.).</li>
                <li><strong>3:30 PM — Workshop</strong> — Collaborative session: how the LIT North America chapter can support the global alumni association and meaningfully contribute to our alma mater.</li>
                <li><strong>5:00 PM — Chapter Business Meeting</strong> — LIT North America chapter updates, future events, membership drive.</li>
                <li><strong>6:30 PM — Evening Dinner &amp; Social</strong> — Sit-down dinner at the venue or a nearby Houston restaurant.</li>
              </ul>

              <h4>Sunday, September 13 — Departure Day</h4>
              <ul>
                <li><strong>10:00 AM — Goodbye Brunch [OPTIONAL]</strong> — Relaxed farewell brunch — group photo, reflections, announce next gathering.</li>
                <li><strong>12:00 PM — Half-Day Houston Sightseeing [OPTIONAL]</strong> — Guided or self-guided tour — Space Center Houston, Museum District, Buffalo Bayou Park, or the Houston Ship Channel.</li>
              </ul>

              <p className="event-note"><em>Items marked [OPTIONAL] are not part of core programming — attendees can arrive Saturday morning and depart Sunday afternoon without missing anything.</em></p>

              <h3>LIT North Star Award</h3>
              <div className="event-north-star">
                <p>
                  LITAANA&apos;s highest annual honor — recognizing excellence in service to our alma mater. Inaugural award presented at the retreat on <strong>Saturday, September 12, 2026</strong> in Houston.
                </p>
                <ul>
                  <li><strong>$5,000 award value</strong> — donated in the recipient&apos;s name to LIT University or an incoming LIT student transitioning to North America (not paid to the recipient personally)</li>
                  <li><strong>Jul 1:</strong> Nominations open (registered LITAANA members; no self-nominations)</li>
                  <li><strong>Aug 1:</strong> Nomination deadline</li>
                  <li><strong>Aug 20:</strong> Recipient selected by 3-member committee</li>
                  <li><strong>Sep 12:</strong> Award presented at the retreat</li>
                </ul>
              </div>

              <h3>Downloads</h3>
              <div className="event-downloads">
                <a
                  href="/downloads/lit-north-star-award-proposal.pdf"
                  download
                  className="event-download-card"
                >
                  <span className="event-download-card__icon">📄</span>
                  <span className="event-download-card__title">LIT North Star Award Proposal</span>
                  <span className="event-download-card__desc">Full award criteria, process, and timeline (PDF)</span>
                </a>
                <a
                  href="/downloads/hotels-near-kensington-dr-sugarland.pdf"
                  download
                  className="event-download-card"
                >
                  <span className="event-download-card__icon">🏨</span>
                  <span className="event-download-card__title">Hotels Near Kensington Dr, Sugar Land</span>
                  <span className="event-download-card__desc">Accommodation options near the event venue (PDF)</span>
                </a>
              </div>

              <h3>Key Planning Workstreams</h3>
              <ul className="event-workstreams">
                <li><strong>Venue</strong> — Hotel meeting room or coworking space for 20–25 on Saturday. Target: book by late July.</li>
                <li><strong>Invitations &amp; RSVPs</strong> — Send save-the-date in July; formal invite in August. Collect separate headcounts for Friday &amp; Sunday optionals.</li>
                <li><strong>Catering &amp; Restaurants</strong> — Friday dinner &amp; Sunday brunch at local restaurants (reserve for 20–25). Saturday breakfast, lunch, and dinner catered.</li>
                <li><strong>Program &amp; Speakers</strong> — Identify 3–4 alumni speakers and a panel moderator by early August. Prepare roundtable and workshop materials.</li>
                <li><strong>Sunday Sightseeing</strong> — Plan a half-day route for up to 25 people. Consider chartered transport for Space Center Houston (~30 min away).</li>
                <li><strong>Memories &amp; Follow-up</strong> — Designate a photographer for Saturday. Send recap email + photos within one week of the event.</li>
              </ul>

              <h3>Rough Budget Estimate (20–25 people)</h3>
              <div className="event-budget-table-wrap">
                <table className="event-budget-table">
                  <thead>
                    <tr>
                      <th>Item</th>
                      <th>Estimated Cost</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr><td>Venue rental (Saturday only)</td><td>$400 – $800</td></tr>
                    <tr><td>Saturday catering (breakfast, lunch + dinner)</td><td>$900 – $1,700</td></tr>
                    <tr><td>Friday dinner (restaurant, shared bill or hosted)</td><td>$300 – $600</td></tr>
                    <tr><td>Sunday brunch (restaurant)</td><td>$200 – $450</td></tr>
                    <tr><td>Sightseeing (transport, entry fees)</td><td>$150 – $400</td></tr>
                    <tr><td>Materials &amp; miscellaneous</td><td>$150 – $300</td></tr>
                    <tr><td><strong>Total estimate</strong></td><td><strong>$2,100 – $4,250</strong></td></tr>
                  </tbody>
                </table>
              </div>
              <p className="event-note"><em>Note: A small per-person registration fee of ~$100 or sponsor funding can offset costs. Budget will be refined once venue and attendee count are confirmed.</em></p>

              <h3>Planning Timeline</h3>
              <ol className="event-timeline">
                <li><strong>Now – July:</strong> Lock Saturday venue and confirm date</li>
                <li><strong>July:</strong> Send save-the-date to all chapter alumni</li>
                <li><strong>August 1:</strong> Confirm 3–4 speakers and panel moderator</li>
                <li><strong>August 15:</strong> Send formal invitation; RSVP deadline</li>
                <li><strong>September 1:</strong> Finalize catering, sightseeing route, and workshop materials</li>
                <li><strong>September 11–13:</strong> RETREAT!</li>
                <li><strong>September 20:</strong> Send recap email and photos to all attendees</li>
              </ol>

              <h3>Your Inputs Needed</h3>
              <ul className="event-inputs-list">
                <li>Do you have suggestions for the Saturday venue in Houston?</li>
                <li>Are you interested in giving a spotlight talk or joining the panel?</li>
                <li>What topics would you like covered in the roundtable discussions?</li>
                <li>Any preferences for the Friday dinner or Sunday sightseeing locations?</li>
                <li>Would you like to volunteer for any planning workstream?</li>
                <li>Any other suggestions or ideas for this inaugural retreat?</li>
              </ul>
              <p>Please reply on our WhatsApp group or reach out directly to the organizing committee.</p>

              <div className="event-rsvp-block">
                <h3>Register for the Retreat</h3>
                {/* Old: Link to="/contactus" Register Your Interest
                <p>We are currently collecting expressions of interest...</p>
                */}
                <p>
                  RSVP via our official Google Form. Save-the-date goes out in July; formal invitation in August with RSVP deadline August 15.
                </p>
                <RegisterButton className="bnt bnt-theme event-register-btn event-register-btn--large">
                  RSVP Now — Google Form
                </RegisterButton>
              </div>

              <h3 style={{ marginTop: '40px' }}>Future Events</h3>
              <p>
                More events are in planning — virtual networking sessions, professional webinars, and regional meetups. Details will be posted here as they are confirmed.
              </p>
            </div>
          </section>

          {/* Event list */}
          <div className="event-calendar">
            <div className="container">
              <div className="top-section text-center">
                <h4>All Alumni Events</h4>
              </div>
              <div className="event-list-content">
                <div className="event-list-item">
                  <div className="date-item">
                    <span className="day text-bold color-theme">11</span>
                    <span className="dates text-gray text-uppercase">FRI</span>
                  </div>
                  <div className="date-desc-wrapper">
                    <div className="date-desc">
                      <div className="date-title">
                        <h4 className="heading-regular">
                          LITAA North America — Inaugural Alumni Weekend Retreat
                        </h4>
                      </div>
                      <div className="date-excerpt">
                        <p>
                          September 11–13, 2026 · Sugar Land, TX · 20–25 alumni. Core programming Saturday, optional events Friday &amp; Sunday.
                        </p>
                      </div>
                      <div className="place">
                        <span className="icon map-icon" />
                        <span className="text-place">{VENUE_ADDRESS}</span>
                      </div>
                    </div>
                  </div>
                  <div className="date-links register text-center">
                    <a
                      href={RSVP_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-regular"
                    >
                      REGISTER
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Whatsapp />
        </div>
        <Footer />
      </div>
    </>
  )
}
